import { FiX } from "react-icons/fi";

export interface ActiveFilterChip {
  id: string;
  label: string;
  onRemove(): void;
  /** Nombre accesible del botón de quitar, p. ej. "Quitar filtro Comida". */
  removeLabel: string;
}

export interface ActiveFilterChipsProps {
  chips: ActiveFilterChip[];
  /** Conteo de resultados, p. ej. "38 movimientos". Se muestra siempre, aunque no haya chips. */
  countLabel: string;
  clearLabel?: string;
  onClear?(): void;
}

/** Filtros activos como chips amarillos quitables, con el conteo de resultados a la derecha. */
export function ActiveFilterChips({ chips, countLabel, clearLabel, onClear }: ActiveFilterChipsProps) {
  return (
    <div className="flex items-center justify-between gap-5">
      {chips.length > 0 ? (
        <ul className="m-0 flex list-none flex-wrap items-center gap-2 p-0">
          {chips.map((chip) => (
            <li key={chip.id} className="inline-flex h-11 items-center gap-1 rounded-full border-[1.5px] border-solid border-[var(--ds-card-sun)] bg-[var(--ds-card-sun)] pl-4 pr-1 text-sm font-medium text-[var(--ds-on-card)] md:h-9">
              <span className="whitespace-nowrap">{chip.label}</span>
              <button
                type="button"
                aria-label={chip.removeLabel}
                onClick={chip.onRemove}
                className="app-focus-ring inline-flex size-11 flex-none items-center justify-center rounded-full bg-transparent md:size-7"
              >
                <FiX aria-hidden="true" className="size-3.5" />
              </button>
            </li>
          ))}
        </ul>
      ) : null}
      <div aria-live="polite" className="ml-auto flex items-center gap-5 text-sm leading-5 text-[var(--ds-ink-muted)]">
        <span>{countLabel}</span>
        {onClear && clearLabel ? (
          <button
            type="button"
            onClick={onClear}
            className="app-focus-ring inline-flex min-h-11 items-center font-medium text-[var(--ds-ink)] underline underline-offset-4"
          >
            {clearLabel}
          </button>
        ) : null}
      </div>
    </div>
  );
}
